import * as auth from "./auth";
import * as studies from "./studies";
import * as profile from "./profile";
import * as econsent from "./econsent";
import * as multieconsent from "./multieconsent";
import * as surveys from "./surveys";
import * as participants from "./participants";
import * as users from "./users";
import * as client from "./client";
import * as queryTool from "./query-tool";
import * as interceptors from "./interceptors";
import * as activity from "./activity";
import * as response from "./response";
import * as sites from "./sites";
import * as edc from "./edc";
import * as studyResponse from "./study-response";
import * as participantweb from "./participantweb";
import * as activityLibrary from "./activity-library";
import * as analytics from "./analytics";
import * as resourcesList from "./resources-list";
import * as participantsPortal from "./participant-portal";
import * as advancedScoring from "./advanced-scoring";
import * as sso from "./sso";
import * as integrations from "./integrations";

const apis = {
  ...auth,
  ...studies,
  ...profile,
  ...econsent,
  ...multieconsent,
  ...surveys,
  ...participants,
  ...users,
  ...client,
  ...queryTool,
  ...interceptors,
  ...activity,
  ...response,
  ...sites,
  ...edc,
  ...studyResponse,
  ...participantweb,
  ...activityLibrary,
  ...analytics,
  ...resourcesList,
  ...participantsPortal,
  ...advancedScoring,
  ...sso,
  ...integrations
};

export default apis;
